import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY, MEMBER_KEY } from './keys';
import { UserGroupApi } from 'api';
import { SearchUserGroupQueryType } from 'types';

function useGetMembers(id: number, query: SearchUserGroupQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY, MEMBER_KEY]).list({ id, ...query }),
    () => UserGroupApi.getMembers(id, query),
    {
      select: (data) => data.data,
      enabled: !!id,
    },
  );
}

export default useGetMembers;
